import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import { LoginButton, useFacebook, useLogin } from 'react-facebook'
import { Form, Input, Modal, Radio } from 'antd'
import { BtnAnch } from 'components/elements/global'
import { TMode } from 'types'
import { BaseButton } from 'components/elements/BaseButton'
import { useAppDispatch } from 'hooks'
import { baseAPI } from 'api/baseApi'
import { InputPhoneNumber } from 'components/elements/Form'
import { TIntegrationItem, TwilioData } from '../types'
import twilio from '../images/twilio.png'
import { useTwilioIntegrationStoreMutation } from '../api'

type TAddTwilioInput = {
 twilio_account_id?: string
 twilio_auth_token?: any
 phone_number?: any
}

const initialValues: TAddTwilioInput = {
 phone_number: '',
 twilio_account_id: '',
 twilio_auth_token: '',
}

export const AddTwlIntergrationModal: FC<{
 editData?: TwilioData
 OnCancel?: () => void
 show?: boolean
 mode?: TMode
 //  intItems: TIntegrationItem[]
 //  setIntItems: Dispatch<SetStateAction<TIntegrationItem[]>>
}> = ({ OnCancel, show, mode, editData }) => {
 const d = useAppDispatch()
 const [mutate, { isLoading }] = useTwilioIntegrationStoreMutation()
 // const [] = useapi

 const [form] = Form.useForm<TAddTwilioInput>()

 const handleSubmit = async () => {
  try {
   const value = await form.validateFields()
   await mutate({
    phone_number: value.phone_number,
    twilio_account_id: value.twilio_account_id,
    twilio_auth_token: value.twilio_auth_token,
   }).unwrap()
   d(baseAPI.util.invalidateTags(['TWL-INT_DTLS']))
   OnCancel?.()
  } catch (error) {
   console.log(error)
  }
 }

 useEffect(() => {
  if (mode === 'EDIT' && editData) {
   const formatted = editData.phone_number?.replace(/[()\s-]/g, '')
   form.setFieldsValue({
    phone_number: `${formatted ?? ''}`,
    twilio_account_id: `${editData.twilio_account_id ?? ''}`,
    twilio_auth_token: `${editData.twilio_auth_token ?? ''}`,
   })
  }
  return () => {
   form.resetFields()
  }
 }, [editData, mode])

 return (
  <Modal
   forceRender
   footer={null}
   onCancel={OnCancel}
   visible={show}
   width={400}
  >
   <div className="int-card-new-header mb-3">
    <img className="int-card-new-img" src={twilio} alt="" />
   </div>
   <Form layout="vertical" form={form} initialValues={initialValues}>
    {/* Chrome autofill prevention trick */}
    <input type="text" style={{ display: 'none' }} autoComplete="off" />
    <input
     type="password"
     style={{ display: 'none' }}
     autoComplete="new-password"
    />
    {/* //>>>>>>>>>> */}
    <Form.Item
     name="twilio_account_id"
     label="Account SID"
     rules={[{ required: true, message: 'Account SID is required' }]}
    >
     <Input type="text" autoComplete="new-password" placeholder="Account SID" />
    </Form.Item>
    <Form.Item
     name="twilio_auth_token"
     label="Auth Token"
     rules={[{ required: true, message: 'Auth Token is required' }]}
    >
     <Input type="password" placeholder="Auth Token" />
    </Form.Item>
    <Form.Item
     name="phone_number"
     label="Phone number"
     rules={[
      { required: true, message: 'Phone number is required' },
      {
       min: 11,
       max: 13,
       message: 'Please enter a valid phone number',
      },
     ]}
    >
     <InputPhoneNumber addonCountry={['us']} />
    </Form.Item>
    <div className="text-center " style={{ marginTop: '25px' }}>
     <BaseButton loading={isLoading} onClick={handleSubmit} type="primary">
      Update
     </BaseButton>
    </div>
   </Form>
  </Modal>
 )

 //  return (
 //   <div className="fb-login-btn">

 //   </div>
 //  )
}
